import Text from 'components/Text/Text';
import TerminalList from './TerminalList';
import React, { useContext } from 'react';
import { IItemDevice, UserRoles } from 'types';
import DataController from 'components/DataController/DataController';
import { DevicesContext, IDevicesContext } from 'modules/Devices/Devices/devicesState/devicesContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemDevice;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setDeviceIDForDeletion, setDeviceIDForFullInfo } = useContext<IDevicesContext>(DevicesContext);
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	const hardwareIdRowClasses = classNames(style.hardwareId, style.row);
	const restaurantRowClasses = classNames(style.restaurant, style.row);
	const customerRowClasses = classNames(style.customer, style.row);
	const terminalIdRowClasses = classNames(style.terminalId, style.row, style.list);
	const tableNumberHeadingClasses = classNames(style.tableNumber, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const handleClickInfo = () => {
		setDeviceIDForFullInfo(data.id);
	};

	const handleSetIdForDeletion = () => {
		setDeviceIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item${index}`}>
			<div className={style.container}>
				<Text className={hardwareIdRowClasses} translationKey={data.hardwareId} withTooltip={true} />
				<Text className={restaurantRowClasses} translationKey={data.restaurantAddress} withTooltip={true} />
				<Text className={customerRowClasses} translationKey={data.customerName} withTooltip={true} />
				<div className={terminalIdRowClasses}>
					<TerminalList terminals={data.deviceBankSettings} />
				</div>
				<Text className={tableNumberHeadingClasses} translationKey={data.tableName} withTooltip={true} />
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={hasAccess ? handleClickInfo : undefined}
						onClickDelete={hasAccess ? handleSetIdForDeletion : undefined}
						URLWithIDToEdit={hasAccess ? `/devices/edit?deviceID=${data.id}` : undefined}
						size="smallBtn"
						isOpenInfo={false}
					/>
				</div>
			</div>
		</div>
	);
};

export default Item;
